<div class="bank-details">
  <div class="bank-details__header">
    <div class="bank-details__title">
      <mat-icon>account_balance</mat-icon>
      <span>Prélèvement bancaire</span>
    </div>
    <mat-slide-toggle
      color="primary"
      [checked]="value.enabled"
      [disabled]="disabled"
      (change)="onEnabledChange($event.checked)">
    </mat-slide-toggle>
  </div>

  <div class="bank-details__body" *ngIf="value.enabled">
    <label class="bank-details__label" [attr.for]="fieldId + '-bank'">Nom de la banque</label>
    <div class="bank-details__select">
      <select
        class="bank-details__input"
        [id]="fieldId + '-bank'"
        [disabled]="disabled || !banks.length"
        [value]="value.bankId"
        (change)="onBankSelect($event)"
        (blur)="markTouched()">
        <option value="">Sélectionner une banque</option>
        <option *ngFor="let bank of banks" [value]="bankCode(bank)">
          {{ bankLabel(bank) }}
        </option>
      </select>
      <mat-icon class="bank-details__affix" aria-hidden="true">expand_more</mat-icon>
    </div>
    <p class="bank-details__empty" *ngIf="!banks.length">Aucune banque disponible.</p>

    <label class="bank-details__label" [attr.for]="fieldId + '-account'">Numéro de compte</label>
    <input
      class="bank-details__input"
      type="text"
      [id]="fieldId + '-account'"
      [disabled]="disabled"
      [value]="value.accountNumber"
      placeholder="Saisir le numéro de compte"
      (input)="onAccountInput($event)"
      (blur)="markTouched()" />
  </div>
</div>
